import React from 'react';
import { FadeIn, Section } from './ui/Section';
import { Check, Clock, Shield, TrendingUp } from 'lucide-react';
export function SolutionSection() {
  return <Section background="white" data-id="element-88">
      <FadeIn className="text-center mb-16" data-id="element-89">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#4A3728] mb-6" data-id="element-90">
          La verdad incómoda
        </h2>
        <p className="text-xl text-[#6B5D52] max-w-2xl mx-auto" data-id="element-91">
          No necesitas un presupuesto perfecto. Necesitas un plan mínimo que te
          devuelva el aire.
        </p>
      </FadeIn>

      {/* The Matrix Reveal */}
      <div className="relative bg-[#FAF7F2] rounded-3xl p-8 md:p-12 border border-[#E8E2D9] shadow-xl mb-20" data-id="element-92">
        <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-[#4A3728] text-[#FAF7F2] px-6 py-2 rounded-full text-sm font-bold tracking-wider uppercase" data-id="element-93">
          El Mecanismo Único
        </div>

        <FadeIn className="text-center mb-12 mt-4" data-id="element-94">
          <h3 className="text-3xl md:text-4xl font-serif font-bold text-[#C4956A] mb-4" data-id="element-95">
            La Matriz Antipánico 3×3
          </h3>
          <p className="text-[#6B5D52]" data-id="element-96">
            Tres palancas. Tres horizontes. 30 minutos.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-97">
          <FadeIn delay={0.1} className="bg-white p-6 rounded-xl border border-[#E8E2D9]" data-id="element-98">
            <div className="w-12 h-12 bg-[#F5F0EB] rounded-full flex items-center justify-center mb-4 text-[#C4956A]" data-id="element-99">
              <Shield className="w-6 h-6" data-id="element-100" />
            </div>
            <h4 className="font-serif font-bold text-xl mb-2 text-[#4A3728]" data-id="element-101">
              1. Pago Mínimo Seguro
            </h4>
            <p className="text-[#6B5D52] text-sm" data-id="element-102">
              Lo mínimo que evita daño inmediato. Sin aspiraciones irreales,
              solo protección.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} className="bg-white p-6 rounded-xl border border-[#E8E2D9]" data-id="element-103">
            <div className="w-12 h-12 bg-[#F5F0EB] rounded-full flex items-center justify-center mb-4 text-[#C4956A]" data-id="element-104">
              <TrendingUp className="w-6 h-6" data-id="element-105" />
            </div>
            <h4 className="font-serif font-bold text-xl mb-2 text-[#4A3728]" data-id="element-106">
              2. Corta-Fugas
            </h4>
            <p className="text-[#6B5D52] text-sm" data-id="element-107">
              Cortar 3 fugas típicas (suscripciones, delivery, fees) para
              recuperar aire inmediato.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} className="bg-white p-6 rounded-xl border border-[#E8E2D9]" data-id="element-108">
            <div className="w-12 h-12 bg-[#F5F0EB] rounded-full flex items-center justify-center mb-4 text-[#C4956A]" data-id="element-109">
              <Clock className="w-6 h-6" data-id="element-110" />
            </div>
            <h4 className="font-serif font-bold text-xl mb-2 text-[#4A3728]" data-id="element-111">
              3. Micro-Colchón
            </h4>
            <p className="text-[#6B5D52] text-sm" data-id="element-112">
              El primer $100–$500 para salir del borde y dejar de vivir al día.
            </p>
          </FadeIn>
        </div>
      </div>

      {/* Benefits */}
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-113">
        <FadeIn data-id="element-114">
          <h3 className="text-2xl font-serif font-bold mb-6 text-[#4A3728]" data-id="element-115">
            Lo que cambia no es tu cuenta... <br data-id="element-116" />
            <span className="text-[#C4956A]" data-id="element-117">es tu cabeza.</span>
          </h3>
          <p className="text-[#6B5D52] mb-6" data-id="element-118">
            Cuando por fin tienes un plan mínimo, pasa algo raro: duermes mejor.
            Porque la ansiedad no viene solo del dinero. Viene de sentir que
            estás a oscuras.
          </p>
          <p className="text-[#6B5D52] font-medium" data-id="element-119">
            Este kit enciende la luz sin lastimarte.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} className="space-y-4" data-id="element-120">
          {['Evita que te caigan fees y penalidades', 'Te devuelve un poco de aire financiero', 'Crea un colchón para emergencias reales', "Sin juicios, sin regaños, sin 'deberías'"].map((item, i) => <div key={i} className="flex items-center" data-id="element-121">
              <div className="w-6 h-6 rounded-full bg-[#C4956A]/20 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-122">
                <Check className="w-4 h-4 text-[#C4956A]" data-id="element-123" />
              </div>
              <span className="text-[#4A3728]" data-id="element-124">{item}</span>
            </div>)}
        </FadeIn>
      </div>
    </Section>;
}